export function sortItemsByField(data, field, direction = 'desc') {
    return [...data].sort((a, b) => {
        const va = a[field];
        const vb = b[field];

        if (typeof va === 'string') {
            return direction === 'desc' ? vb.localeCompare(va) : va.localeCompare(vb);
        }

        return direction === 'desc' ? vb - va : va - vb;
    });
}

export function groupItemsByStar(items) {
    return items.reduce((acc, item) => {
        const star = item.star ?? 3;
        if (!acc[star]) {
            acc[star] = [];
        }
        acc[star].push(item);
        return acc;
    }, {});
}

export function sortItemsByPreference(items, preferenceId, dailyTheme) {
    if (!items?.length) {
        return [];
    }

    const themeTags = new Set(dailyTheme?.favoredTags ?? []);

    const getPreferenceScore = (item) => {
        let score = 0;

        if (preferenceId && preferenceId !== 'all') {
            if (item.mood === preferenceId) {
                score += 4;
            }

            if (item.tags?.includes(preferenceId)) {
                score += 3;
            }
        }

        if (item.tags?.some((tag) => themeTags.has(tag))) {
            score += 2;
        }

        if (item.mood === dailyTheme?.mood) {
            score += 1;
        }

        return score;
    };

    return [...items].sort((a, b) => {
        const scoreDiff = getPreferenceScore(b) - getPreferenceScore(a);
        if (scoreDiff !== 0) {
            return scoreDiff;
        }

        return (b.star ?? 0) - (a.star ?? 0);
    });
}
